import React, { Component } from 'react';
import { inject, observer } from "mobx-react";
import { Row, Spin } from "antd";
import Pdf from "./Pdf";
import Rank from "./Rank";
import Proportion from "./Proportion";
import RoomsRank from "./RoomsRank";
import moment from "moment";
import "./index.scss";

@inject('store')
@observer
class index extends Component {
    componentDidMount() {
        this.props.store.allHotel.getData();
        window.addEventListener('resize', () => {
            if (window.location.hash === '#/table/bi_headquarters') {
                this.props.store.allHotel.onResize();
            }
        });
    }
    render() {
        const { loading = false } = this.props.store.allHotel;
        return (
            <div className="general">
                <Row className="title">BI Structure - Corporate Office 总部数据平台 <span className="bi-date">{moment().subtract(1, 'month').format('YYYY-MM')}</span></Row>
                <Spin spinning={loading}>
                    <Rank />
                    <RoomsRank />
                    <Proportion />
                    <Pdf />
                </Spin>
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/BI/headquarters/index.js